import $ from 'jquery';

const setLottie = () => {
  $('.js-lottie').each(function () {
    let dataSrc;
    // if ($(this).data('srcSp')) {
    //   dataSrc = window.innerWidth > 767.9 ? 'srcPc' : 'srcSp';
    // } else {
      dataSrc = 'src';
    // }
    const src = $(this).data(dataSrc);
    const loopInterval = $(this).data('loop-interval'); // インターバル時間（ミリ秒）
    
    const animation = lottie.loadAnimation({
      container: this,
      renderer: 'svg',
      loop: loopInterval ? false : true, // インターバルがある場合はループをfalseに
      autoplay: true,
      path: src,
    });

    // ループインターバルが設定されている場合
    if (loopInterval) {
      animation.addEventListener('complete', () => {
        setTimeout(() => {
          animation.goToAndPlay(0); // 最初から再生
        }, loopInterval);
      });
    }
  });
};

const init = () => {
  setLottie();
};

export default init;